// extracted by mini-css-extract-plugin
export default {"input-box":"BudgetInput_input-box__0Scyr","label":"BudgetInput_label__vQlET","input":"BudgetInput_input__KQxEC","hidden-label":"BudgetInput_hidden-label__M7MF2"};